'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLocalPlay = function MdLocalPlay(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25.9 28l-1.8-6.8 5.5-4.6-7-0.3-2.6-6.6-2.6 6.6-7.1 0.3 5.6 4.6-1.8 6.8 5.9-3.9z m7.5-8c0 1.8 1.4 3.4 3.2 3.4v6.6c0 1.8-1.4 3.4-3.2 3.4h-26.8c-1.8 0-3.2-1.6-3.2-3.4v-6.6c1.8 0 3.2-1.6 3.2-3.4s-1.4-3.4-3.2-3.4v-6.6c0-1.8 1.4-3.4 3.2-3.4h26.8c1.8 0 3.2 1.6 3.2 3.4v6.6c-1.8 0-3.2 1.6-3.2 3.4z' })
        )
    );
};

exports.default = MdLocalPlay;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/local-play.js
// module id = 1701
// module chunks = 168707334958949